import { useSignal } from "@preact/signals";
import Button from "$store/components/ui/Button.tsx";
import Icon from "$store/components/ui/Icon.tsx";

interface Props {
  url?: string;
}

export default function ShareCopyProductLink({ url }: Props) {
  if (!url) return null;

  const openShare = useSignal(false);

  function handleToClipBoard() {
    if (!url) return;
    navigator.clipboard.writeText(url);
    openShare.value = false;
  }

  return (
    <Button onClick={handleToClipBoard}>
      <div class="bg-tw-neutral-200 rounded-[50%] h-8 w-8 flex justify-center items-center mx-auto mb-2">
        <Icon width={15} height={15} id="SharePdp" />
      </div>
      <span class="text-tw-neutral-400">
        Copiar Link
      </span>
    </Button>
  );
}
